import '@vfde-brix/card-picture-cta/dist/styles.css';
import '@vfde-brix/image-caption/dist/styles.css';
import '@vfde-brix/button/dist/styles.css';
import { createCardPictureCtaComponent } from '@vfde-brix/card-picture-cta';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/core';
import { createComponents } from '../../utils/initComponents';

createComponents('brix-card-picture-cta', createCardPictureCtaComponent, NO_PATTERN_BUSINESS_LOGIC, element => element);
